module.exports = __webpack_public_path__ + "img/100-points-narrowing.a6bcf756.png";